import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { OfacMatchesTable } from '../../../../../../../../../../features/watchlist/ofac/match/ofac-match-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingComplianceOfac,
      label: 'Matches',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingComplianceOfac>,
  head: () => getPageHead('OFAC Matches'),
  component: OfacMatchList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return <PageTabRail actions={filter} group={TabbedNavigationGroup.ClearingComplianceOfac} />;
}

function OfacMatchList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <OfacMatchesTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
